import { Box, Grid, Stack, Typography } from "@mui/material";
import React, { FC } from "react";
import { useTheme } from "@mui/material/styles";
import { UsersIcon } from "../UIElements/svgIcons";
import useResponsive from "../../hooks/useResponsive";
import { InfoBox } from "../designUi";
import { DashboardStats } from "../../interface/dashboard";

export default function DashboardInfo({ stats }: { stats: DashboardStats }) {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");

  return (
    <Grid container>
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        <InfoBox
          title={"Hospitals"}
          value={stats.totalFacility}
          icon={<UsersIcon />}
        />
      </Grid>
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        <InfoBox
          title={"Medics"}
          value={stats.totalMedics}
          icon={<UsersIcon />}
        />
      </Grid>{" "}
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        <InfoBox title={"Jobs"} value={stats.totalJobs} icon={<UsersIcon />} />
      </Grid>{" "}
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        <InfoBox
          title={"Job applications"}
          value={stats.totalApplications}
          icon={<UsersIcon />}
        />
      </Grid>
    </Grid>
  );
}
